import React from "react";
import { Progress } from "semantic-ui-react";
import {
  LaunchStatusEvent,
  LaunchStatusType,
  StreamerStatus,
} from "@pureweb/platform-sdk";
import { COUNT_STEPS, DEFAULT_HUMAN_READABLE_STATUS } from "../../constants";

interface LoadingViewProps {
  LaunchRequestStatus: LaunchStatusEvent;
  StreamerStatus: StreamerStatus;
  humanReadableStatus?: Record<string, string>;
}

export const LoadingView: React.FC<LoadingViewProps> = ({
  LaunchRequestStatus,
  StreamerStatus: streamerStatus,
  humanReadableStatus = DEFAULT_HUMAN_READABLE_STATUS,
}) => {
  if (
    streamerStatus === StreamerStatus.Connected ||
    streamerStatus === StreamerStatus.Completed
  ) {
    return <div />;
  }

  let content;

  if (streamerStatus === StreamerStatus.NotSupported) {
    content = (
      <div>
        <h3>
          Your browser does not support the necessary WebRTC capabilities.
        </h3>
      </div>
    );
  }

  if (
    LaunchRequestStatus.status === LaunchStatusType.Unavailable ||
    LaunchRequestStatus.status === LaunchStatusType.Error ||
    streamerStatus === StreamerStatus.Failed
  ) {
    content = (
      <div>
        <h3>The experience is presently unavailable.</h3>
        <h3>Please refresh to request a new session.</h3>
      </div>
    );
  } else {
    // Remove background image
    document.body.style.setProperty("background-image", "none");

    content = (
      <div>
        <div>
          <Progress
            color="grey"
            size="tiny"
            percent={
              ((COUNT_STEPS.indexOf(LaunchRequestStatus.status) + 1) /
                COUNT_STEPS.length) *
              100
            }
            active
          />
        </div>
        <h3>{humanReadableStatus[LaunchRequestStatus.status]}</h3>
      </div>
    );
  }

  return (
    <>
      <video
        src="/videos/loading-video.mp4"
        className="fixed w-screen h-screen object-cover"
        height="100%"
        autoPlay
        loop
        muted
      >
        <source src="/videos/loading-video.mp4" type="video/mp4"></source>
        <track kind="captions"></track>
      </video>
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "90%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <div style={{ textAlign: "center" }}>{content}</div>
      </div>
    </>
  );
};
